import React from "react";
import { Box, IconButton } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate, useLocation } from "react-router-dom";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { Icon: HomeIcon,          path: "/home",    label: "Inicio" },
    { Icon: SearchIcon,        path: "/members", label: "Buscar" },
    { Icon: AccountCircleIcon, path: "/profile", label: "Perfil" },
  ];

  return (
    <Box sx={{
      position: "fixed",
      bottom: 20,
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 1300,
      display: "flex",
      alignItems: "center",
      background: "rgba(8,11,20,0.88)",
      backdropFilter: "blur(24px)",
      WebkitBackdropFilter: "blur(24px)",
      border: "1px solid rgba(255,255,255,0.1)",
      borderRadius: "50px",
      padding: "6px 10px",
      gap: 0.5,
      boxShadow: "0 8px 32px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.05)",
    }}>
      {items.map(({ Icon, path, label }) => {
        const isActive =
          location.pathname === path ||
          (path === "/home" && location.pathname === "/");
        return (
          <IconButton
            key={path}
            onClick={() => {
              if (isActive) {
                navigate(path, { state: { refresh: Date.now() }, replace: true });
              } else {
                navigate(path);
              }
            }}
            sx={{
              borderRadius: "28px",
              px: 2.5,
              py: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 0.3,
              background: isActive
                ? "linear-gradient(135deg, rgba(0,212,255,0.18), rgba(123,47,247,0.18))"
                : "transparent",
              border: isActive ? "1px solid rgba(0,212,255,0.25)" : "1px solid transparent",
              transition: "all 0.25s ease",
              "&:hover": {
                background: isActive
                  ? "linear-gradient(135deg, rgba(0,212,255,0.28), rgba(123,47,247,0.28))"
                  : "rgba(255,255,255,0.06)",
              },
            }}
          >
            <Icon sx={{
              color: isActive ? "#00d4ff" : "rgba(255,255,255,0.4)",
              fontSize: "1.4rem",
              transition: "color 0.25s",
              filter: isActive ? "drop-shadow(0 0 6px rgba(0,212,255,0.6))" : "none",
            }} />
            <Box component="span" sx={{
              fontSize: "0.58rem",
              color: isActive ? "#00d4ff" : "rgba(255,255,255,0.3)",
              fontWeight: isActive ? 700 : 400,
              letterSpacing: "0.5px",
              lineHeight: 1,
              fontFamily: "inherit",
            }}>
              {label}
            </Box>
          </IconButton>
        );
      })}
    </Box>
  );
};

export default BottomNav;

